"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageBox = void 0;
var _tsUtils = require("@ori/ts-utils");
var _Image = require("./Image");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const ImageBox = ({
  buttons,
  labels,
  productCode,
  productImageUrls
}) => {
  const {
    iconButton
  } = buttons ?? {};
  const {
    deal,
    ppa
  } = labels ?? {};
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.ImageBoxRoot, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.ImageWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Image.Image, {
        productImageUrls: productImageUrls
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Ppa, {
        label: ppa?.title,
        type: ppa?.labelKey,
        productCode: productCode,
        size: "small"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Deal, {
      label: deal?.title,
      type: deal?.labelKey,
      productCode: productCode
    }), (0, _tsUtils.isNonNullable)(iconButton) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.IconButtonWrapper, {
      children: iconButton
    }) : null]
  });
};
exports.ImageBox = ImageBox;
